/** Format KSEF: 10 - 8 - 12 - 2 znaków alfanumerycznych (litery i cyfry) */
export const KSEF_NUMBER_PATTERN = /^[A-Za-z0-9]{10}-[A-Za-z0-9]{8}-[A-Za-z0-9]{12}-[A-Za-z0-9]{2}$/;

/** Formatuje wpis: tylko litery i cyfry, myślniki po 10, 18, 30 znakach. */
export function formatKsefNumber(val: string | null): string {
  if (val == null) return '';
  const chars = (val + '').replace(/[^A-Za-z0-9]/g, '').slice(0, 32);
  const a = chars.slice(0, 10);
  const b = chars.length > 10 ? chars.slice(10, 18) : '';
  const c = chars.length > 18 ? chars.slice(18, 30) : '';
  const d = chars.length > 30 ? chars.slice(30, 32) : '';
  return a + (b ? '-' + b : '') + (c ? '-' + c : '') + (d ? '-' + d : '');
}
